import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-33" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-[860px] px-4 sm:px-6" data-id="element-34" data-mp="1hb8ewdd9odov">
        <h2 className="text-center text-[24px] font-bold leading-none text-white sm:text-[38px]" data-id="element-35" data-mp="1cft27oqzwnu1">
          Frequently asked <span className="text-brandorange" data-id="element-36" data-mp="2a1h1cheu5k99">questions</span>
        </h2>

        <div className="mt-5 divide-y divide-line border border-line bg-carbon" data-id="element-37" data-mp="25473qeham2ac">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-38" data-mp="1v5hjwg5u67rg" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors duration-150 ease-out hover:bg-panel2" data-id="element-39" data-mp="1v4g5c1pm334z">
                  <span className="font-display text-[14.5px] uppercase leading-tight text-white sm:text-[17px]" data-id="element-40" data-mp="1klvthrinz3sj">
                    {faq.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-brandorange" strokeWidth={3} data-id="element-41" data-mp="1fonajopoyvq8" /> : <PlusIcon className="h-4 w-4 shrink-0 text-brandorange" strokeWidth={3} data-id="element-42" data-mp="11v5wgjfryb7l" />}
                </button>
                {isOpen && <p className="px-4 pb-3 text-[13.5px] font-medium leading-snug text-metal sm:text-[15px]" data-id="element-43" data-mp="wxmf3ans5ibf">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}